<template>
	<el-config-provider :locale="zhCn">
		<router-view />
	</el-config-provider>
    <!-- 登录弹窗 -->
    <LoginDialog
      v-model:visible="loginVisible"
      @login="handleLogin"
      @switch-to-register="switchToRegister"
    />

    <!-- 注册弹窗 -->
    <RegisterDialog
      v-model:visible="registerVisible"
      @register="handleRegister"
      @switch-to-login="switchToLogin"
    />
</template>

<script setup lang="ts">
import { ElConfigProvider, ElMessage } from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import { useThemeStore } from './store/theme';
import { onMounted, ref, watch } from "vue";
import LoginDialog from '@/views/pc/login/index.vue';
import RegisterDialog from '@/views/pc/register/index.vue';
import { userData } from './store/userData';
// ***************登录*****************
const authStore = useAuthStore();

// 弹窗显示状态
const loginVisible = ref(false)
const registerVisible = ref(false)

// 打开登录弹窗
const openLoginDialog = () => {
  loginVisible.value = true
}

// 打开注册弹窗
const openRegisterDialog = () => {
  registerVisible.value = true
}

// 处理登录逻辑（模拟异步请求）
const handleLogin = async (account: string, password: string) => {
  loginApi( {
    username: account,
    password: password
  });
}

// 处理注册逻辑（模拟异步请求）
const handleRegister = async (account: string, password: string) => {
  registerApi( {
    username: account,
    password: password
  });
}
// 从登录切换到注册
const switchToRegister = () => {
  loginVisible.value = false
  registerVisible.value = true
}

// 从注册切换到登录
const switchToLogin = () => {
  registerVisible.value = false
  loginVisible.value = true
}
watch(
  () => authStore.showTopUpCount,
  (newVal, oldVal) => {
    if( authStore.loginKey == null ){
        loginVisible.value = true;
    }
  }
);

const theme = useThemeStore();
theme.initTheme();
/*************************  Api请求  *******************************/
//登录
const loginApi = async (param: any) => {
    ajax({
        url: "user/login",
        method: 'POST', // 修正参数名称
        data: param,
        success: (res) => {
            if( res.code == 0){
                ElMessage.success(res.msg);
                // 设置用户的权限
                // if( res.data.permiss == undefined){
                //     ElMessage.error("该账户没有权限进入系统，请联系管理员！");
                //     return;
                // }
                authStore.setLoginKey(res.data.token);
                // 将用户名存储到 localStorage 中
                sessionStorage.setItem('loginKey', res.data.token);      
                userData().setAll(res.data);
                loginVisible.value = false;
                registerVisible.value = false;
            }
            else {
                ElMessage.error(res.msg);
            }
        }
    });
};
// 注册
const registerApi = async (param: any) => {
    ajax({
        url: "user/register",
        method: 'POST', // 修正参数名称
        data: param,
        success: (res) => {
            if( res.code == 0){
                ElMessage.success(res.msg);
            }
            else{
                ElMessage.error(res.msg);
            }
        }
    });
};

</script>
<style>
@import './assets/css/main.css';
</style>

<style scoped>

</style>